module.exports = __webpack_public_path__ + "static/media/outlook-calendar.a9ad0ed1.svg";